export const maxSnackbars = 2;
export const snackbarAutoHideDuration = 8000;
export const receiptSnackbarAutoHideDuration = 5000;
/**
 * Represents an *autoHideDuration* value in milliseconds for a specific custom snackbar intended to show receipt item
 * approvement event or it's fail.
 */
export const workflowItemProcessedSnackbarDuration = 30 * 1000;
/** Receipt section should have full control of `keydown` event, this class helps to handle window events.
 *  It shows if an event should be handled in `window.keydown` event in {@link ItemWorkflowVirtualizedTable} component.
 */
export const catchInsideWindowKeyDownEventClassName = 'ciwkdecn';
/**
 *  Marks the element if an `ArrowUp` and `ArrowDown` events should be handled in {@link ItemWorkflowVirtualizedTable} component.
 */
export const catchArrowUpDownEventClassName = 'caudecn';
export const warehouseAppSidebarWidth = '206px';
/**
 * Specifies the value (in milliseconds) that is higher than stockman's scanner key press speed.
 *
 * Helps determine whether it is stockman's manual input by keyboard or it is scanner's input.
 *
 * We have to add a very small debounce in search text fields for a scanner, since a scanner
 * sends `1` -> `12` -> `123` -> `1234` -> `12345` -> `Enter` -> `Enter` -> `Enter` instead of `12345`+`Enter` altogether.
 *
 * (*Ketex* old frontend delay was: `100` ms.)
 */
export const warehouseScannerCharacterInputSpeedMs = 10;
// export const warehouseScannerCharacterInputSpeedMs = 10;
/**
 * Specifies the time (in milliseconds) that is necessary to avoid multiple `Enter` key presses on stockman's scanner input.
 *
 * A scanner enters characters one by one, followed by multiple presses of the `Enter` button, which can cause multiple
 * confirmations of product acceptance. That's why a throttle should be used.
 *
 * (It sends `1` -> `2` -> `3` -> `4` -> `5` -> `Enter` -> `Enter` -> `Enter`)
 */
export const enterKeyPressThrottleWaitTimeMs = 100;
/**
 * Should be used when no stock location is selected yet.
 */
export const defaultStockLocationId = undefined;
/**
 * DescriptionList term column width inside small narrow dialogs like ApproveReceiptItem, AssignPlace, BlockReceiptItem, etc.
 */
export const narrowDialogDescriptionListTermWidth = '40%';
// /**
//  * Default viewport increase value for a virtualized table with about 1-300 rows.
//  */
// export const defaultSmallTableViewportIncreaseValue = 3000;
/**
 * Default viewport increase value for a virtualized table with about 300-800 rows.
 *
 * Example: Invoice tables.
 *
 * (This value, used with virtualized table with 1000+ rows will force the virtualization to lag so much.)
 */
export const defaultMediumTableViewportIncreaseValue = 800;
/**
 * Default viewport increase value for a virtualized table with more than 800+ rows.
 *
 * 3000 for example, will force virtualization to lag so much.
 *
 * Example: Verification tables.
 */
export const defaultLargeTableViewportIncreaseValue = 1000;
